import { Translatable } from "@icc/shared/helpers";

export class AdditionalPolystyreneInsert {
    id: number;
    /** Kod zewnętrzny */
    extId: string;
    /** Kod do indeksu */
    indexNo: string;
    /** Kod do wydruków */
    printCode: string;
    @Translatable({ model: 'Profiles' })
    name: string;
    /** Zdjęcie */
    img: string;
    /** Opis */
    description: string;
    /** Przypisane typy produktu */
    shutterTypesIds: number[];
    /** Pasujące skrzynki */
    blindBoxesIds?: number[];
}